export default __webpack_public_path__ + "static/media/m_diagram1.e6ff6d1b.png";